/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:f6e7af37-aa21-4b4c-8b10-c38cc8a50553",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_rui63CTcq",
    "aws_user_pools_web_client_id": "3ho1t40u5mpkgtravsedg6ij1k",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "superadmin373c719988ca4a539d5d0cb8df873b19cc569-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
